import React from "react";

import allBrandIcons from "../Brands/Brands";
import { SingleColorIconProps } from "../types";

import SingleColorIcons from "./SingleColorIcons";

export const Icon: React.FC<SingleColorIconProps> = ({
  icon,
  color,
  width,
  height,
  className,
  "data-testid": testId,
  ...props
}) => {
  const IconSelector = SingleColorIcons[icon] ?? allBrandIcons[icon];
  return (
    <IconSelector
      className={className}
      color={color}
      width={width}
      height={height}
      data-testid={testId}
      {...props}
    />
  );
};
